module.exports = __webpack_public_path__ + "static/media/Appstore button.decfb2f0.png";